/**
 * Najčešća cijena među oglasnicima — normala prema kojoj se mjeri odstupanje.
 *
 * Vraća `null` kad jasne većine nema: sve cijene različite, ili više njih izjednačeno po
 * učestalosti. Bez normale ne bi se imalo što istaknuti, pa se tada ne boji ništa.
 */
export const findMajorityPrice = (prices: (number | null)[]): number | null => {
  const counts = new Map<number, number>();

  for (const price of prices) {
    if (price == null) continue;

    counts.set(price, (counts.get(price) ?? 0) + 1);
  }

  let majority: number | null = null;
  let topCount = 0;
  let isTied = false;

  counts.forEach((count, price) => {
    if (count > topCount) {
      majority = price;
      topCount = count;
      isTied = false;
      return;
    }

    if (count === topCount) isTied = true;
  });

  // Jedno pojavljivanje nije većina — to je lista samih različitih cijena.
  if (topCount < 2 || isTied) return null;

  return majority;
};
